module.exports = __webpack_public_path__ + "static/strokeweight-100-dc31a061b1939d9cdcd2439e57332acf.woff2";